import React from 'react';

import { Box } from '@vk-hr-tek/ui/Box';
import { WysiwygContent } from '@vk-hr-tek/ui/WysiwygContent';
import { useInject } from '@vk-hr-tek/core/ioc';

import { ContentSurveyQuestion } from '@app/gen/community';
import { ContentService } from '@app/gen/content';

import { ContentSurveysFreeText } from './ContentSurveysFreeText';
import { ContentSurveysSingleChoice } from './ContentSurveysSingleChoice';
import { ContentSurveysMultipleChoice } from './ContentSurveysMultipleChoice';

interface ContentSurveysItemQuestionProps {
  fieldIndex: number;
  question: ContentSurveyQuestion;
}

export const ContentSurveysItemQuestion = ({
  fieldIndex,
  question,
}: ContentSurveysItemQuestionProps) => {
  const contentService = useInject(ContentService);

  const { content, answer_settings: answerSettings } = question;

  const getAttachmentUrl = async (attachmentId: string) => {
    const { url } = await contentService.getAttachmentUrl({
      params: { attachment_id: attachmentId },
    });

    return url;
  };

  const getQuestionContent = () => {
    switch (answerSettings.object.answer_type) {
      case 'free_text':
        return (
          <ContentSurveysFreeText
            fieldIndex={fieldIndex}
            answerSettings={answerSettings.object}
          />
        );
      case 'multiple_text_choice':
        return (
          <ContentSurveysMultipleChoice
            fieldIndex={fieldIndex}
            answerSettings={answerSettings.object}
          />
        );
      case 'single_text_choice':
        return (
          <ContentSurveysSingleChoice
            fieldIndex={fieldIndex}
            answerSettings={answerSettings.object}
          />
        );
    }
  };

  return (
    <Box display="flex" flexDirection="column" gap="16">
      <WysiwygContent
        editorStateJSON={JSON.parse(content?.data || '{}')}
        getAttachmentUrl={getAttachmentUrl}
      />
      {getQuestionContent()}
    </Box>
  );
};
